import commonMutations from '@/store/data/common/mutations'

const mutations = {
    ...commonMutations
}

export default mutations
